import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import { AuthProvider } from "./context/AuthContext";
import FloatingContact from "./components/feature/FloatingContact";
import ScrollToTop from "./components/base/ScrollToTop";
import PageTransition from "./components/base/PageTransition";


function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <AuthProvider>
        <BrowserRouter basename={__BASE_PATH__}>
          <ScrollToTop />
          <PageTransition>
            <AppRoutes />
          </PageTransition>
          <FloatingContact />
        </BrowserRouter>
      </AuthProvider>
    </I18nextProvider>
  );
}

export default App;
